import { Component, ElementRef, Input, ChangeDetectionStrategy, inject } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { Router, RouterLink } from '@angular/router';
import { formatDate } from '../utils';
import { InfoMap } from 'src/app/models/info-card.models';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { NgClass } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { BreakpointService } from 'src/app/services/breakpoint.service';

export class Interpolation {
  constructor(public str: string, public value: string) {}
}

@Component({
  selector: 'app-info-card',
  templateUrl: './info-card.component.html',
  styleUrls: ['./info-card.component.scss'],
  providers: [TranslatePipe],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [TranslatePipe, MatCardModule, MatButtonModule, NgClass, RouterLink, AngularSvgIconModule],
})
export class InfoCardComponent {
  @Input() title: string | Interpolation | undefined;
  @Input() description: string | undefined;
  @Input() iconUrl: string | undefined;
  @Input() infoMap?: InfoMap[];
  @Input() headerRouterLink: string | undefined;
  @Input() columns = 3;
  @Input() solution = '';
  @Input() isMapInfoCard = false;
  /** On phones, show only this many entries until "Show more" is pressed. Unset: always show everything. */
  @Input() collapsedItems?: number;

  readonly bp = inject(BreakpointService);
  expanded = false;

  /** True when the card is a phone card that has entries hidden behind "Show more". */
  get collapsible(): boolean {
    return this.collapsedItems !== undefined && this.bp.isPhone() && (this.infoMap?.length ?? 0) > this.collapsedItems;
  }

  isHidden(index: number): boolean {
    return this.collapsible && !this.expanded && index >= (this.collapsedItems ?? 0);
  }

  constructor(public element: ElementRef, private translate: TranslatePipe, private router: Router) {}

  getTitle(): string {
    if (typeof this.title === 'string') {
      return this.translate.transform(this.title) as string;
    } else if (this.title instanceof Interpolation) {
      return (this.translate.transform(this.title.str) as string).replace(/%value%/g, this.title.value);
    } else {
      return '';
    }
  }

  valueIsDate(value: string | Date): boolean {
    return value instanceof Date;
  }

  navigate(path: string): void {
    void this.router.navigate([path]);
  }

  formatInfoDate(date: string | Date): string {
    if (date instanceof Date) return formatDate(date);
    return '';
  }
}
